import {AnagramSDK} from './anagram-sdk'

;(() => {
  const currentScript = document.currentScript as HTMLScriptElement | null

  if (!currentScript) {
    console.error('[Anagram] No <script> context found.')
    return
  }

  try {
    new AnagramSDK(currentScript).boot()
  } catch (error) {
    console.error('[Anagram] Failed to initialize:', error)
  }
})()
